import React from 'react';
import FragmentButtonTabs from '@app/component/tabs/FragmentButtonTabs';
import { CalendarIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import ReviewsPropertyInsightsWeeklyDigest
	from '@app/site/secured/review-manager/fragment/property-overview/_insights/ReviewsPropertyInsightsWeeklyDigest';
import ReviewsPropertyInsightsMonthlyDigest
	from '@app/site/secured/review-manager/fragment/property-overview/_insights/ReviewsPropertyInsightsMonthlyDigest';
import ReviewsPropertyInsightsEmailSettings
	from '@app/site/secured/review-manager/fragment/property-overview/_insights/ReviewsPropertyInsightsEmailSettings';

const ReviewsPropertyInsights = React.memo(() => {
	return <>
		<FragmentButtonTabs options={[
			{
				label: 'Weekly Digest',
				icon: <CalendarIcon className="-ml-0.5 w-4 h-4" />,
				link: '/secured/review-manager/property-overview/insights',
				fragment: <ReviewsPropertyInsightsWeeklyDigest />,
			},
			{
				label: 'Monthly Digest',
				icon: <CalendarIcon className="-ml-0.5 w-4 h-4" />,
				link: '/secured/review-manager/property-overview/insights/monthly-digest',
				fragment: <ReviewsPropertyInsightsMonthlyDigest />,
			},
			{
				label: 'Email Settings',
				icon: <EnvelopeIcon className="-ml-0.5 w-4 h-4 text-gray-400"/>,
				link: '/secured/review-manager/property-overview/insights/email-settings',
				fragment: <ReviewsPropertyInsightsEmailSettings />,
			}
		]} />
	</>;
});

export default ReviewsPropertyInsights;
